import React from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'
import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  content: {
    borderRadius: 'var(--border-radius-lg)',
    backgroundColor: 'var(--theme-color-surface-d0)'
  },
  borderedContent: {
    borderRadius: 'var(--border-radius-lg)',
    border: '2px solid #E9EAEF',
    minWidth: '16rem'
  },
  columnContent: {
    display: 'flex',
    flexDirection: 'column'
  }
}))

const SectionContent = ({ borderedContent, columnContent, style, children }) => {
  const classes = useStyles()

  return (
    <div
      className={clsx(classes.content, {
        [classes.borderedContent]: borderedContent,
        [classes.columnContent]: columnContent
      })}
      style={style}
    >
      {children}
    </div>
  )
}

SectionContent.propTypes = {
  style: PropTypes.object,
  children: PropTypes.node,
  columnContent: PropTypes.bool,
  borderedContent: PropTypes.bool
}

export default SectionContent
